import { menuAction } from "@/store/actions/menu";
import { getMenuActive } from "@/store/reducers/menu";
import { useDispatch, useSelector } from "react-redux";

export const useMenu = () => {
  const appDispatch = useDispatch();
  const { changeMenuActive } = menuAction;
  const menuSelected = useSelector(getMenuActive);

  const atualizarMenuSelected = (key: string[]) => {
    appDispatch(changeMenuActive(key));
  };

  return {
    atualizarMenuSelected,
    menuSelected,
  };
};
